import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  ContextMenuItemState,
  BfxBlotterContextMenuItem,
  BfxBlotterAction,
  ContextMenuState,
} from "../../../shared/cubiq-services";
import { BfxLadderBlotterContextMenuEvent } from "../../bfx-base-blotter/bfx-base-blotter-contextmenu.service";

/* 
 * Intervention menu structure
 * + MenuItem[]
 * - + ItemState
 * + MenuState

*/

export type PortfolioPricingReference = { portfolioId: string; diEventId: string };

/* Intervention - ItemState */
export class BfxInterventionContextMenuItemState extends ContextMenuItemState {
  public traderReference: Map<CubiqTS.AcceptanceType, string[]> = new Map<
    CubiqTS.AcceptanceType,
    string[]
  >();
  public pricingReference: Array<string> = new Array<string>(); // used for manual pricing unlock

  public portfolioReferences: PortfolioPricingReference[] = []; // used for FWd Roll Price and Clear
  constructor() {
    super();
  }
}

/* Intervention - MenuItem */
export class BfxInterventionContextMenuItem extends BfxBlotterContextMenuItem<any> {
  public state: BfxInterventionContextMenuItemState = new BfxInterventionContextMenuItemState();
  constructor(
    public actionId: BfxBlotterAction,
    title: string = "",
    public iconClass: string = null,
  ) {
    super(
      actionId,
      title,
      () => {
        return;
      },
      () => {
        return;
      },
    );
    this.state.title = title;
    this.state.enabled = null;
    this.state.available = null;
    if (typeof iconClass === "string") {
      this.state.iconClass = iconClass;
    }
  }
}

/* Intervention - MenuState */
export class BfxBlotterInterventionContextMenuState extends ContextMenuState {
  public canAcceptAsTrader: boolean;
  public canRejectAsTrader: boolean;
  public hasDITraderUnrestricted: boolean;
  public canAmendMarkup: boolean;
  public canPriceFixRate: boolean;

  public canPriceFwdRoll: boolean;
  public canClearFwdRoll: boolean;
  public canRetryFwdRoll: boolean;

  public canApproveAsSales: boolean;
  public canRejectAsSales: boolean;
  public canApproveUnrestrictedAsSales: boolean;
  public canClearAsSales: boolean;

  public canCancelOrder: boolean;
  public canCancelAndModifyOrderUnrestricted: boolean;

  public canUnlockOrders: boolean;
  public optimisticUnlockEnable: boolean = false;

  public canEnterMarkupBmark: boolean;
  public canEnterMarkupLimits: boolean;
  public canEnterMarkupAlgo: boolean;

  public isTrader: boolean;
  public isSales: boolean;
  public isClient: boolean;

  public canDIApproveFill: boolean;
  public canDICancelFill: boolean;
  public canDIClearFill: boolean;

  constructor() {
    super();
  }

  public reset(): void {
    super.reset();
  }
}

/* Intervention Blotter - MenuEvent */
export class BfxLadderBlotterInterventionContextMenuEvent extends BfxLadderBlotterContextMenuEvent<CubiqTS.InterventionEventImpl> {}
